/***
 * Класс управления данными корзины, избранного и сравнения
 */
class UserRest {
	/**
	 * Установка данных пользовательских классов
	 * @param basket{Object|undefined} - объект корзины
	 * @param favorite{Array|undefined} - массив избранного
	 * @param compare{Array|undefined} - массив сравнения
	 */
	static setData = ({ basket, favorite, compare }) => {
		if (basket) window.Block.Basket.setData({ basket, update: false });
		if (favorite) window.Block.Favorite.setData({ favorite, update: false });
		if (compare) window.Block.Compare.setData({ compare, update: false });
		window.Block.ProductControl?.updateControl();
		window.Block.GiftSetControl?.updateControl();
	};
}

// Экспорт;
window.Block.UserRest = UserRest;
